import styled from 'styled-components';

export const TopBarStyled = styled.div`
  background-color: white;
  border-bottom: 1px solid ${props => props.theme.uiColors.multiflightMapTopBarBorder};
  box-shadow: 0 1px 2px 0 ${props => props.theme.uiColors.multiflightMapTopBarShadow};
  width: 100%;

  .topbar {
    &__container {
      align-items: center;
      column-gap: 40px;
      display: flex;
      justify-content: space-between;
      padding: 8px 16px;
    }

    &__info {
      background-color: var(--color-sonata-primary-200, #F2F5FC);
      border-radius: 4px;
      column-gap: 8px;
      display: flex;
      padding: 12px 16px;
      height: 32px;

      &Separator {
        background-color: var(--color-sonata-primary-300, #DDE9FD);
        border-radius: 40px;
        height: 16px;
        width: 1px;
      }
    }

    &__count {
      align-items: center;
      column-gap: 8px;
      display: flex;

      &Number {
        color: var(--color-sonata-primary-800, #162237);
        font: var(--font-body-400-bold);
      }

      &Text {
        color: var(--color-sonata-primary-500, #7B9FE1);
        font: var(--font-info-600-regular);
      }
    }

    &__search {
      align-items: center;
      column-gap: 40px;
      display: flex;

      &SelectorDropdown {
        align-items: center;
        column-gap: 8px;
        display: flex;
      }

      &Dropdown {
        width: 332px;
      }

    }
  }
`;
